import React from 'react';

interface SubscriptionProtectedRouteProps {
  children: React.ReactNode;
}

// Suscripción deshabilitada temporalmente: todos los usuarios tienen acceso completo.
const SubscriptionProtectedRoute: React.FC<SubscriptionProtectedRouteProps> = ({
  children,
}) => {
  return <>{children}</>;
};

export default SubscriptionProtectedRoute;
